"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _debounce_as_promise = _interopRequireDefault(require("./utils/debounce_as_promise"));
var _reject_stale_tasks = _interopRequireDefault(require("./utils/reject_stale_tasks"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useAsyncItems = function useAsyncItems(itemFetcher) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$debounceWait = options.debounceWait,
    debounceWait = _options$debounceWait === void 0 ? 275 : _options$debounceWait,
    _options$preventLoadO = options.preventLoadOnMount,
    preventLoadOnMount = _options$preventLoadO === void 0 ? false : _options$preventLoadO;
  var callback = React.useMemo(function () {
    return (0, _debounce_as_promise["default"])((0, _reject_stale_tasks["default"])(itemFetcher), debounceWait);
  }, [itemFetcher, debounceWait]);
  callback.preventLoadOnMount = preventLoadOnMount;
  return callback;
};
var _default = exports["default"] = useAsyncItems;